"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.right-container .jobsPortal {\n  width: 100%;\n  max-width: 293px;\n  height: min-content; }\n  .right-container .jobsPortal .job .title {\n    font-size: 12px; }\n\n@media (max-width: 42rem) {\n  .right-container .jobsPortal {\n    max-width: 100%; } }\n";
  const fileName = "JobPortal_JobPortal";
  const element = document.querySelector("style[data-sass-component='JobPortal_JobPortal']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const JobPortal = _ref => {
  let {
    label,
    items,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "jobsPortal sia-border-01-bottom sia-padding-03-top sia-padding-03-right sia-padding-02-left sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "main-tag sia-text-01 sia-margin-01-bottom"
  }, label['cms.newsletter.jobs-portal.title']), /*#__PURE__*/_react.default.createElement("div", null, items?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "job"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "title sia-text-10 "
    }, el.corporate), /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-margin-01-top"
    }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      isCMS: false,
      items: [{
        link: {
          title: el.job,
          original_url: `/jobs/offers/${el.open_position_id}`
        }
      }],
      lang: lang
    })));
  })));
};
var _default = exports.default = JobPortal;